/**
 * The canonical V2 message channel keys.
 *
 * Kept in its own dependency-free module (no `effect`/`Schema` import) so the
 * list and the helpers built from it (label map, type guard) can be consumed by
 * environments — e.g. the support app's jest unit tests — that can't load
 * `effect` at runtime. {@link ./message} builds the `MessageChannel` schema from
 * this array.
 */
export const USER_FACING_MESSAGE_CHANNELS = [
  "gmail",
  "outlook",
  "customEmail",
  "redoChat",
  "facebookDm",
  "facebookComments",
  "instagramDm",
  "instagramComments",
  "sms",
  "voice",
  "attentive",
  "postscript",
  "tiktok",
  "contactForm",
  "internalNote",
  "mobileMessage",
] as const;
export type UserFacingMessageChannel =
  (typeof USER_FACING_MESSAGE_CHANNELS)[number];

/**
 * A chat card and a press on one. Only a message is on these, never a thread,
 * and users never see them named: they read as the chat they belong to.
 */
export const HIDDEN_MESSAGE_CHANNELS = [
  "uiComponent",
  "uiComponentResult",
] as const;
export type HiddenMessageChannel = (typeof HIDDEN_MESSAGE_CHANNELS)[number];

export const MESSAGE_CHANNELS = [
  ...USER_FACING_MESSAGE_CHANNELS,
  ...HIDDEN_MESSAGE_CHANNELS,
] as const;
